// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__380AW","fullView":"styles_fullView__XMNlR"};